export const name = 'rnLanguage';
/**
 * @ngdoc service
 * @name rhino.components.language.service:rnLanguage
 * @description This service provides the client application with the ability to query the server for the list of available
 * language packs for a given user (browser) side language.
 * @deprecated Use rnLocale instead (focusing on locales instead of languages)
 */
export default function rnLanguage($http, $log, $q, $window, $cookies) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var defaultLanguage = {value:"en", name:"English"};
  var languageListServiceUrlResource = '/api/portal/v1/i18n/listlanguages/';
  var self = this;

  var service = {
    getServiceLanguages: getServiceLanguages,
    getBestFitLanguageForUser: getBestFitLanguageForUser,
    setLanguageCookie: setLanguageCookie,
    getBrowserLanguage: getBrowserLanguage,
    defaultLanguage: defaultLanguage,
    getLanguageServiceUrl: getLanguageServiceUrl,
    getCurrentLanguage: getCurrentLanguage
  };

  return service;


  /////////////////////
  // Private functions
  ////////////////////

  /**
   * @ngdoc function
   * @name getLanguageServiceUrl
   * @methodOf rhino.components.language.service:rnLanguage
   * @description Generate the correct service URL for the given applicationName and browserLanguage
   * @param {string} applicationName - the name of the desired application
   * @param {string} browserLanguage - the language of the browser
   * @returns {string} the correctly formatted service url
   */
  function getLanguageServiceUrl(applicationName, browserLanguage) {
    return languageListServiceUrlResource + applicationName + '/' + browserLanguage;
  }

  /**
   * @ngdoc function
   * @name getServiceLanguages
   * @methodOf rhino.components.language.service:rnLanguage
   * @description Query the server for the list of available languages for the given applicationName.  Note that different
   * applications may have different languages available
   * @param {string} applicationName - the name of the application that you want to get the list of available languages for
   * @returns {*} a promise which, when resolved will be an array of language name objects
   */
  function getServiceLanguages(applicationName) {
    var deferred = $q.defer();
    var url = getLanguageServiceUrl(applicationName, getBrowserLanguage());
    $http.get(url)
      .then(resp => {
        deferred.resolve({
          success: true,
          result: resp.data
        });
      })
      .catch(() => {
        //availableLanguages = [defaultLanguage];
        deferred.reject({
          success: false,
          result: "Failed to get Service languages"
        });
      });
    return deferred.promise;
  }

  /**
   * @ngdoc function
   * @name getBrowserLanguage
   * @methodOf rhino.components.language.service:rnLanguage
   * @description Get the w3c language code from the browser.  This represents the language that the borwser is currently configured
   * to use
   * @returns {string|*} the language code
   */
  function getBrowserLanguage() {
    var lang = $window.navigator.language || $window.navigator.browserLanguage || $window.navigator.userLanguage;
    if(lang === undefined) {
      lang = $window.navigator.languages ? $window.navigator.languages[0] : null;
    }
    return lang;
  }

  /**
   * @ngdoc function
   * @name setLanguageCookie
   * @methodOf rhino.components.language.service:rnLanguage
   * @description Set a cookie for the given user indicating their selected langauge
   * @param {object} signinData - the user session info that is required to generate a cookie
   * @param {string} userSelectedLanguage - the name of the user selected language
   */
  function setLanguageCookie(signinData, userSelectedLanguage) {
    //if(selectedLanguage.value != vm.signinData.language.value) {
    //The user has changed their desired language on the login form, so write a cookie containing the desired language
    // MD is adding a $$mdSelectId to the language object - pick out only the elements we want in the cookie.
    $cookies.putObject('userSelectedLanguage', _.pick(signinData.language, 'value', 'name'), {path: '/'});
    $log.debug("Saved user selected language in cookie: " + $cookies.getObject(userSelectedLanguage));
    //}
  }

  /**
   * @ngdoc function
   * @name getBestFitLanguageForUser
   * @methodOf rhino.components.language.service:rnLanguage
   * @description Given the list of available languages and the current language mode of the browser, try to select the best fit
   * language for the user.  Language fit will attempt to start out as specific as possible and will become more
   * generic until a suitable match is found
   * @param {array[]} availableLanguages an array of the available languages as provided by the server for the application
   * @returns {value: string, name: string} the best fit language
   */
  function getBestFitLanguageForUser(availableLanguages) {
    var lang = defaultLanguage;
    //first, see if the user has previously selected a language
    if($cookies.get('userSelectedLanguage') !== undefined) {
      $log.debug('Attempt to parse $cookies.userSelectedLanguage');
      lang = $cookies.getObject('userSelectedLanguage');
      $log.debug('Result is: ', lang);
    }
    //second, try to get the browsers language
    else {
      lang = getBrowserLanguage();
      //now try to match a language object from the service...
      //try an exact match first..
      var match = false;
      for (var i = 0; i < availableLanguages.length; i++) {
        if(lang === availableLanguages[i].value) {
          lang = availableLanguages[i];
          match = true;
          break;
        }
      }
      //failing an exact match, try a highest level language match... (i.e. the first part... en-us would match en)
      if(match === false) {
        for (i = 0; i < availableLanguages.length; i++) {
          if(lang.indexOf(availableLanguages[i].value) === 0) {
            lang = availableLanguages[i];
            match = true;
            break;
          }
        }
      }
      //worst case, we could not match anything
      if(match === false) {
        lang = defaultLanguage;
      }
    }
    return lang;
  }

  function getCurrentLanguage() {
    //first, see if the user has previously selected a language
    if($cookies.get('userSelectedLanguage') !== undefined) {
      return $cookies.getObject('userSelectedLanguage');
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/language/language.service.js